import React from 'react';

import {
  Checkbox as MaterialCheckbox,
  CheckboxProps as MaterialCheckboxProps,
} from '@mui/material';

import { Label, Container } from './styles';

interface CheckboxProps extends MaterialCheckboxProps {
  label: string | React.ReactNode;
  checked: boolean;
  handleChange?:
    | ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void)
    | undefined;
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  handleChange,
  ...rest
}: CheckboxProps) => {
  return (
    <Container>
      <Label
        control={<MaterialCheckbox checked={checked} onChange={handleChange} {...rest} />}
        label={label}
      />
    </Container>
  );
};

export default Checkbox;
